import { createAction, props } from '@ngrx/store';
import { gridState } from './shared.models';

//Action for getCountry.
export const getCountry = createAction('[Shared/API] getCountry');
export const getCountrySuccess = createAction(
  '[Shared/API] getCountry Success',
  props<{ countryList: any }>()
);
export const getCountryFailure = createAction(
  '[Shared/API] getCountry Failure',
  props<{ error: any }>()
);

//Action for getStates.
export const getStates = createAction('[Shared/API] getStates', props<{ payload: any }>());
export const getStatesSuccess = createAction(
  '[Shared/API] getStates Success',
  props<{ stateList: any }>()
);
export const getStatesFailure = createAction(
  '[Shared/API] getStates Failure',
  props<{ error: any }>()
);

//Action for getPlan.
export const getPlan = createAction('[Shared/API] getPlan', props<{ description: any }>());
export const getPlanSuccess = createAction(
  '[Shared/API] getPlan Success',
  props<{ planList: any }>()
);
export const getPlanFailure = createAction('[Shared/API] getPlan Failure', props<{ error: any }>());
export const setPlanListFromCache = createAction(
  '[Shared/Cache] Set Plan List From Cache',
  props<{ planList: any }>()
);
export const clearPlanList = createAction('[Shared] Clear Plan List');
//Action for isEmailExist.
export const isEmailExist = createAction('[Shared/API] isEmailExist', props<{ payload: any }>());
export const isEmailExistSuccess = createAction(
  '[Shared/API] isEmailExist Success',
  props<{ validateEmail: [] }>()
);
export const isEmailExistFailure = createAction(
  '[Shared/API] isEmailExist Failure',
  props<{ error: any }>()
);

export const clearEmailVal = createAction('[Shared/API] Clear Email Validation');
export const hideShowLoader = createAction(
  '[Shared/API] Hide Loader',
  props<{ isLoaded: boolean }>()
);

//Action for toaster
export const ToasterSuccess = createAction(
  '[Shared/API] Display Success Toaster',
  props<{ description: string }>()
);
export const ToasterWarning = createAction(
  '[Shared/API] Display Warning Toaster',
  props<{ description: string }>()
);
export const ToasterError = createAction(
  '[Shared/API] Display Error Toaster',
  props<{ description: string }>()
);

//To clear search filter field after successful add/edit/delete/copy
export const clearSearchFilter = createAction(
  '[Shared/API] clear search Filter',
  props<{ isClearSearch: boolean }>()
);

//Action to get all gridConfigs
export const getAllGridConfig = createAction('[Shared/API] Get All Grid List');
export const getAllGridConfigSuccess = createAction(
  '[Shared/API] Get All Grid List Success',
  props<{ allGridConfig: any }>()
);
export const getAllGridConfigFailure = createAction(
  '[Shared/API] Get All Grid List Failure',
  props<{ error: any }>()
);

//Action for setting grid configuration in store
export const setGridCofiguration = createAction(
  '[Shared/API] Set Grid Configuration',
  props<{ gridState: any }>()
);

//Action to get grid configuration in store
export const getGridCofiguration = createAction(
  '[Shared/API] Get Grid Configuration',
  props<{ gridState: any }>()
);

//Action to update grid configuration in store
export const updateGridCofiguration = createAction(
  '[Shared/API] Update Grid Configuration',
  props<{ payload: any }>()
);
export const updateGridCofigurationSuccess = createAction(
  '[Shared/API] Update Grid Configuration Success',
  props<{ gridState: any; message: any }>()
);
export const updateGridCofigurationFailure = createAction(
  '[Shared/API] Update Grid Configuration Failure',
  props<{ error: any }>()
);
